import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs.ui";
import Button from "../../components/core/button.core";
import { PlusIcon } from "lucide-react";

export default function CampaignsPartial() {
  const { pathname } = useLocation();
  const tab = pathname.split("/").pop();
  const initialTab = tab ? tab : "profile";
  const [activeTab, setActiveTab] = useState(initialTab);
  const navigate = useNavigate();
  return (
    <div className="bg-white py-4 w-full h-full overflow-x-auto">
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center md:px-12 md:pt-5 pb-5 w-full">
          <h2 className="font-cabinetgrotesk font-semibold text-2xl">
            Your campaigns
          </h2>

          <Button
            onClick={() => navigate("/brands/campaigns/create")}
            className="flex items-center p-0 w-60 h-16"
          >
            <PlusIcon />
            Create new campaign
          </Button>
        </div>

        <Tabs
          className="flex flex-col h-full"
          value={activeTab}
          onValueChange={(value) => {
            setActiveTab(value);
            navigate(`/brands/campaigns/${value}`);
          }}
        >
          <div className="-top-4 z-10 md:sticky bg-white py-1.5 pl-16 border-black border-t border-b w-full">
            <TabsList className="flex justify-between w-64 font-cabinetgrotesk">
              <TabsTrigger value="live">Live</TabsTrigger>
              <TabsTrigger value="draft">Draft</TabsTrigger>
              <TabsTrigger value="closed">Closed</TabsTrigger>
            </TabsList>
          </div>
          <TabsContent className="flex-1" value={activeTab}>
            <Outlet />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
